// Module
var code = "<div> <h2>{{$ctrl.greeting}}</h2> <span translate>Welcome back to {{$ctrl.appName}}. Here's what's been happening.</span> </div> ";
// Exports
module.exports = code;